// DEPRECATED: superseded by InboundTriggerNodeInfo (inboundEventType='email'/'sms').
// Kept so existing published InboundEventTrigger workflows continue to render.
// Remove after all InboundEventTriggerWorkflow rows are migrated to InboundTriggerWorkflow.
import type { LBNodeData } from '@/proto/logiblocks/logiblocks';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { InboundEventTriggerCustomization } from './InboundEventTriggerCustomization';
import { buildNodeData } from '../../nodeDataUtils';
import { LogoutIcon } from '@/assets/icons/icons';

export const InboundEventTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'inbound_event_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Inbound event',

  hasInput: false,

  getIcon: (size: number) => <LogoutIcon width={size} height={size} />,

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const courierIds = data.inbound_event_trigger?.courier_ids || [];
    const teamIds = data.inbound_event_trigger?.team_ids || [];
    const originIds = data.inbound_event_trigger?.origin_ids || [];
    const destinationIds = data.inbound_event_trigger?.destination_ids || [];

    const hasAnyFilter =
      courierIds.length > 0 ||
      teamIds.length > 0 ||
      originIds.length > 0 ||
      destinationIds.length > 0;

    return hasAnyFilter ? 'Filtered' : 'All Inbound Calls';
  },

  CustomizationComponent: InboundEventTriggerCustomization,

  createDefaultNodeData: () =>
    buildNodeData('inbound_event_trigger', {
      courier_ids: [],
      team_ids: [],
      origin_ids: [],
      destination_ids: [],
    }),
};
